import { ThemeProvider } from "@material-ui/styles";
import "./auth.scss";

import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Plotigo } from "assets/Plotigo";
import { Topography } from "assets/Topography";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { GetParam } from "utils/tools";
import LeftContent from "./component/LeftContent";
import RightContent from "./component/RightContent";

const LoginPage = ({ theme }: any) => {
  const param = GetParam();
  const [isUnauthorizedUser, setIsUnauthorizedUser] = useState(false);

  useEffect(() => {
    if (param.get("err") === "1") {
      setIsUnauthorizedUser(true);
    }
  }, [param.get("err")]);

  return (
    <ThemeProvider theme={theme}>
      <Helmet>
        <title>WTS School Bus - Login</title>
      </Helmet>
      <Topography />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div
          style={{
            zIndex: 1,
            backgroundColor: "#fff",
            boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
            borderRadius: "0.375rem",
            width: "1100px",
            height: "500px",
            marginBottom: "80px",
          }}
        >
          <div style={{ display: "flex", width: "100%", height: "100%" }}>
            <LeftContent />
            <RightContent />
          </div>
        </div>
      </div>
      <div
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          backgroundColor: "#fff",
          height: "80px",
          padding: "0 2rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "1.25rem",
          color: "#555555",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: "1.25rem",
          }}
        >
          <Plotigo />
          <div style={{ fontSize: "1rem" }}>
            Powered by
            <span style={{ fontWeight: "bolder" }}> Plotigo</span>
          </div>
        </div>
        Copyright {new Date().getFullYear()} Woodlands Transport Service Pte Ltd
        All rights reserved.
      </div>
      {isUnauthorizedUser && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={isUnauthorizedUser}
          autoHideDuration={6000}
          onClose={() => setIsUnauthorizedUser(false)}
        >
          <Alert severity="error" elevation={6} variant="filled">
            Unauthorized User!
          </Alert>
        </Snackbar>
      )}
    </ThemeProvider>
  );
};

export default LoginPage;
